module.exports = __webpack_public_path__ + "img/bg1.275bd40b.png";